<div
  class="date-picker udex-px-sm-0 d-flex"
>
  <udex-date-picker
    class="date-picker__input"
    [value]="getFormattedMomentDate()"
    [label]="'configurator.startDate' | cxTranslate"
    [maxDate]="maxDate"
    [minDate]="minDate"
    value-state="Standard"
    [disabled]="isDatepickerDisabled$ | async"
    selection-mode="Single"
    (selection-change)="onSelectionChange($event)"
  ></udex-date-picker>
  <div *ngIf="dates.endDate" class="date-picker__end-date min-input-height udex-ms-sm-16 body--s">
    <div class="align-self-center">
      <span class="text-grey" data-cy="end-date-label">
        {{ 'configurator.date.endDate' | cxTranslate }}
        <span *ngIf="dates.endDate">{{ parseDateToFormat(dates.endDate) }}</span>
      </span>
      <ng-container *ngIf="endDateTooltipContent$ | async">
        <dcp-icon-button-tooltip placement="Right" [openOnClick]="true" accessibleName="durationTooltip">
          <span>{{ endDateTooltipContent$ | async }}</span></dcp-icon-button-tooltip>
      </ng-container>
    </div>
  </div>
  <div *ngIf="dates.years" class="align-self-center">
    <p class="text-grey udex-m-0">
      {{ 'configurator.date.yearsAndMonths' | cxTranslate: dates }}
    </p>
  </div>
</div>
